import { useEffect, useRef, useState } from 'react';
import { supabase } from '../supabaseClient';
import { generateChecklist, perfilParaMotor, type ChecklistItem } from './compliance-engine';

// Ítems GA y SP del motor para los apartados del menú (bloque 7, B y C). Solo lee
// company_sso_profile (no corre los syncs del Checklist ni escribe nada). Se vuelve
// a leer al salir del Perfil SSO, donde se responden las preguntas que deciden el
// "aplica".
export function useItemsAnexo(companyId: string | undefined, habilitado: boolean, active: string): ChecklistItem[] {
  const [items, setItems] = useState<ChecklistItem[]>([]);
  const [recarga, setRecarga] = useState(0);
  const anterior = useRef(active);

  useEffect(() => {
    if (anterior.current === 'sso-perfil' && active !== 'sso-perfil') setRecarga(n => n + 1);
    anterior.current = active;
  }, [active]);

  useEffect(() => {
    if (!companyId || !habilitado) { setItems([]); return; }
    let vigente = true;
    supabase
      .from('company_sso_profile')
      .select('*')
      .eq('company_id', companyId)
      .maybeSingle()
      .then(({ data, error }) => {
        if (!vigente) return;
        if (error) console.error('No se pudo leer el Perfil SSO para el menú:', error.message);
        const c = generateChecklist(perfilParaMotor(error ? null : data));
        setItems(c.items.filter(i => i.id.startsWith('GA-') || i.id.startsWith('SP-')));
      });
    return () => { vigente = false; };
  }, [companyId, habilitado, recarga]);

  return items;
}
